export default function () {
  const ls = localStorage.getItem('auth')
  return ls ? (JSON.parse(ls)?.locale ?? null) : null
}
